<template>
  <div class="doctor-schedule-page">
    <!-- 标题 -->
    <div class="banner">
      <div class="title">医生出诊信息公示</div>
    </div>
    <div class="doctor-schedule-table">
      <!-- 表头 -->
      <div class="table-row">
        <div class="cell">出诊日期</div>
        <div class="cell">科室名称</div>
        <div class="cell">医生姓名</div>
      </div>
      <van-empty v-if="doctorList.length == 0" description="暂无医生出诊信息！" />
      <van-list
          v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="queryYsczlList"
      >
        <!-- 表体 -->
        <div
            v-for="(item, index) in doctorList"
            :key="index"
            class="table-row"
        >
          <div class="cell">{{ item.zzrq }}</div>
          <div class="cell">{{ item.ksmc }}</div>
          <div class="cell">{{ item.ysxm }}</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import {getYsczList} from "@/api/hdTCM";

export default {
  name: 'DoctorSchedule',
  data() {
    return {
      pageNo:1,
      pageSize:10,
      loading: false,// 当loading为true时，转圈圈
      finished: false,// 数据是否请求结束，结束会先显示- 没有更多了 -
      doctorList: []
    };
  },
  mounted() {
    this.pageNo=1
    this.doctorList=[]
    this.queryYsczlList();
  },
  methods:{
    //医生坐诊
    queryYsczlList(){
      getYsczList({ym:this.pageNo,myhs:this.pageSize}).then(res=>{
        if(res.success){
          this.loading = false;
          this.doctorList=this.doctorList.concat(res.result);
          this.pageNo++;
          // 校验是否加载完毕
          if (res.result.length === 0) {
            this.finished = true;
          }else{
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      })
    }
  }
};
</script>

<style scoped="scoped">
.doctor-schedule-page {
  background-color: #fff;
  min-height: 100vh;
}

.banner {
  background: #5F7DF7;
  color: white;
  padding: 20px;
  border-radius:  0 0 20px 20px;
  text-align: center;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.doctor-schedule-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: #A1A1A1;
}

.table-row {
  display: flex;
  align-items: center;
  min-height: 44px;
  border-bottom: 1px solid #A8CAE2;
}

.cell {
  flex: 1;
  text-align: center;
  padding: 0 6px;
  box-sizing: border-box;
}

/* 科室列略宽 */
.table-row .cell:nth-child(2) {
  flex: 1.5;
}
</style>